export const networkedDOMProtocolSubProtocol_v0_1 = "networked-dom-v0.1";
